import { api } from '../DefaultService';
import { ILicenseSimpleProps, ILicenseUpdatePayload } from './types';

const ENDPOINT = '/v1/licenses';

const getApiErrorMessage = (error: any): string => {
  return error?.response?.data?.message || 'Erro interno do servidor!';
};

export const getAllLicensesAsync = async (): Promise<ILicenseSimpleProps[]> => {
  return await api
    .get<ILicenseSimpleProps[]>(ENDPOINT)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(getApiErrorMessage(error));
    });
};

export const getCurrentLicenseAsync = async (): Promise<ILicenseSimpleProps> => {
  return await api
    .get<ILicenseSimpleProps>(`${ENDPOINT}/current`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(getApiErrorMessage(error));
    });
};

export const getLicenseByIdAsync = async (
  id: string,
): Promise<ILicenseSimpleProps> => {
  return await api
    .get<ILicenseSimpleProps>(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(getApiErrorMessage(error));
    });
};

export const updateLicenseAsync = async (
  id: string,
  payload: ILicenseUpdatePayload,
): Promise<void> => {
  return await api
    .put(`${ENDPOINT}?id=${encodeURIComponent(id)}`, payload)
    .then(() => undefined)
    .catch((error) => {
      throw new Error(getApiErrorMessage(error));
    });
};
